import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TriangleArrowDownIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M30.5575 9.85743L17.6381 24.2575C16.7499 25.2475 15.2502 25.2475 14.362 24.2575L1.44246 9.85743C0.471796 8.77541 1.20297 7 2.61932 7H29.3806C30.797 7 31.5282 8.77541 30.5575 9.85743Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
